module.exports = __webpack_public_path__ + "static/media/mastodon.9cae5d15.svg";